module.exports = __webpack_public_path__ + "static/media/maize.df530c06.jpg";